<div class="default-mu-sidebar {{ baseClass }}" style="opacity: 0" [ngClass]="{ 'mu-sidebar-select': skin }">
  <div (click)="closeSidebar()"></div>
  <div class="{{ contentClass }} mu-right-content">
    <app-mu-toast [key]="'toast-sidebar'" [position]="'top-right'"></app-mu-toast>
    <i class="fas fa-times mu-sidebar-close" (click)="closeSidebar()" aria-hidden="true"></i>
    <ng-content></ng-content>
  </div>
</div>
